// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"7dd01910","168":"e5bc7cfb","660":"56d80a2f","787":"fe077e44","850":"1f8cf34b","927":"ea37a340"}[chunkId] + ".chunk.js";
};